import styled from '@emotion/styled';
import { Form, InputNumber } from 'antd';

const InpNumberComponent = styled(InputNumber)({
  '.ant-input-number-handler-wrap': {
    display: 'none',
  },
});

export function InputCurrency({
  defaultValue = 1000,
  placeholder = '',
  required = false,
  inputProps = undefined,
  rules = [],
  ...props
}) {
  return (
    <Form.Item
      rules={[{ required, message: `กรุณากรอก${props.label}` }, ...rules]}
      noStyle={inputProps?.type === 'hidden'}
      {...props}
    >
      <InpNumberComponent
        defaultValue={defaultValue}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
        {...inputProps}
        style={{ width: '100%' }}
        placeholder={placeholder || `กรอก${props.label}`}
      />
    </Form.Item>
  );
}
